const chinesePinyinCollator = new Intl.Collator('zh-CN-u-co-pinyin', {
  sensitivity: 'base',
  numeric: true,
});

function chineseName(category) {
  const names = category && category.i18n_name;
  return String((names && (names.ZH_HANS || names.zh_CN)) || '').trim();
}

export function sortCmsCategoryOptions(categories) {
  return [...(categories || [])].sort((left, right) => {
    const leftName = chineseName(left);
    const rightName = chineseName(right);

    if (!leftName || !rightName) {
      if (leftName) return -1;
      if (rightName) return 1;
    }

    const lengthDifference = Array.from(leftName).length - Array.from(rightName).length;
    if (lengthDifference !== 0) return lengthDifference;

    const nameDifference = chinesePinyinCollator.compare(leftName, rightName);
    if (nameDifference !== 0) return nameDifference;

    return String(left && left.key || '').localeCompare(String(right && right.key || ''));
  });
}
